<script lang="ts">
  import Button from './Button.svelte';
  let {
    message,
    retry,
    title = 'Non riesco a caricare questa sezione',
    retryLabel = 'Riprova',
  }: { message: string; retry?: () => void; title?: string; retryLabel?: string } = $props();
</script>

<section class="inline-state error-state" role="alert">
  <div>
    <strong>{title}</strong>
    <p>{message}</p>
  </div>
  {#if retry}
    <Button onclick={retry}>{retryLabel}</Button>
  {/if}
</section>
